module.exports = __webpack_public_path__ + "static/media/pencil.39b9d8ae.svg";